//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState({
      userInfo: state => state.d2admin.userInfo
    })
  },
  methods: {
    ...mapActions([
      'd2adminLogout'
    ]),
    /**
     * @description 登出
     */
    logOff () {
      this.d2adminLogout({
        vm: this,
        confirm: true
      })
    }
  }
}
